module.exports = __webpack_public_path__ + "img/under-maintenance-dark.27addd55.svg";